export default __webpack_public_path__ + "static/media/calendar-dots_blue.600859b3.svg";